import React from 'react';
import { Empty } from 'antd';

const Forbidden = () => (
  <Empty description="未授权的访问" />
);

export default Forbidden;
